import { IGetPriceInfoDetailScales, IPriceInfoResponseData } from '../actions/get-price-info.action';
import { IPostCartItems } from '../actions/post-cart.action';
import { ILocalizationState } from '../states/localization-state';
import { formatNumberLocaleStatic } from './format-number';

/**
 *
 * @param product
 * @returns formatted string
 */
export const formatPriceIndication = (product: IPostCartItems | IPriceInfoResponseData, localizationState: ILocalizationState): string => {
    const { PriceAmount, PriceCurrency, PriceFactor, PriceUnit } = product;

    if (PriceAmount) {
        const formattedPriceAmount = formatNumberLocaleStatic(Number(PriceAmount), localizationState);
        const formattedPriceIndication = PriceAmount
            ? `${formattedPriceAmount} ${PriceCurrency} / ${
                  Number(PriceFactor) === 1 ? '' : formatNumberLocaleStatic(Number(PriceFactor), localizationState)
              } ${PriceUnit}`
            : ``;
        return formattedPriceIndication;
    } else {
        return '';
    }
};

/**
 *
 * @param scale
 * @param priceInformation
 * @returns formatted string
 */
export const formatScalePriceIndication = (
    scale: IGetPriceInfoDetailScales,
    priceInformation: IPriceInfoResponseData,
    localizationState: ILocalizationState
): string => {
    const { PriceUnit, PriceCurrency, PriceFactor } = priceInformation;
    const { PriceAmount } = scale;
    if (PriceAmount) {
        const formattedPriceAmount = formatNumberLocaleStatic(Number(PriceAmount), localizationState);
        const formattedScalePriceIndication = `<span class="break-after">${formattedPriceAmount}</span> <span class="break-after">${PriceCurrency} / ${
            Number(PriceFactor) === 1 ? '' : PriceFactor
        } ${PriceUnit}</span>`;
        return formattedScalePriceIndication;
    } else {
        return '';
    }
};
